import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { weekStartsOn } from '@app/global-constants';
import { icon } from '@components/icon/icon.interface';
import { CalendarEvent, CalendarView } from 'angular-calendar';
import { isSameDay, isSameMonth, isToday } from 'date-fns';

import { CalendarDatesParams } from './calendar-dates-params.interface';
import { CalendarService } from './calendar.service';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CalendarComponent implements OnInit {
  @Input() data: CalendarEvent[];
  @Output() readonly datesChange = new EventEmitter<CalendarDatesParams>();
  @Output() readonly eventClick = new EventEmitter<any>();
  readonly calendarViewOptions: { id: string; icon: icon; label: string; value: CalendarView }[] = [
    {
      id: 'dzien-radio-input',
      icon: 'calendar-view-day',
      label: $localize`Dzień`,
      value: CalendarView.Day,
    },
    {
      id: 'tydzien-radio-input',
      icon: 'calendar-view-week',
      label: $localize`Tydzień`,
      value: CalendarView.Week,
    },
    {
      id: 'miesiac-radio-input',
      icon: 'calendar-view-month',
      label: $localize`Miesiąc`,
      value: CalendarView.Month,
    },
  ];
  readonly calendarView = CalendarView;
  readonly weekStartsOn = weekStartsOn;
  view = CalendarView.Week;
  viewDate = new Date();
  activeDayIsOpen = false;

  constructor(
    private readonly calendarService: CalendarService,
    private readonly elRef: ElementRef<CalendarComponent & HTMLElement>,
  ) {}

  get locale(): string {
    return this.calendarService.locale;
  }

  ngOnInit(): void {
    if (isToday(this.viewDate)) {
      setTimeout(() => {
        const el = this.elRef.nativeElement.getElementsByClassName('cal-current-time-marker').item(0);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
        }
      }, 0);
    }
    this.onDateChange();
  }

  closeActiveDayView(): void {
    this.activeDayIsOpen = false;
  }

  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      if ((isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) || events.length === 0) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
      this.viewDate = date;
    }
  }

  onDateChange(): void {
    this.datesChange.emit(this.calendarService.getDateParams(this.view, this.viewDate));
  }
}
